interface InputFieldProps {
  label: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string
}

const InputField = ({ label, value, onChange, placeholder, type = "text", required, disabled,name }: InputFieldProps) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`w-full px-4 py-2.5 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#2462b2]/20 focus:border-[#2462b2] transition-all ${
          disabled ? "bg-gray-50 cursor-not-allowed" : "hover:border-[#2462b2]/50"
        }`}
      />
    </div>
  );
};

export default InputField;
